var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncreaseRevenue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m331 448.15v60h-150v-60l77.944-30z",
    fill: "#ffdf40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 419.283v88.867h75v-60l-72.056-30z",
    fill: "#ffbe40"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362 328.15v60l75 30 75-30v-60z",
    fill: "#ffdf40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Increase_49_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m150 508.15h-150v-60h150z",
    fill: "#ffdf40"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m181 388.15v60h150v-60z",
    fill: "#ffbe40"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m512 448.15v60h-150v-60l77.944-30z",
    fill: "#ffdf40"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m432.1 3.85-135.601 82.2 36 16.8c-1.199 2.1-2.699 3.9-3.9 5.7-20.099 30.901-44.7 57.9-72.599 80.7-54.6 45-122.1 73.5-194.099 80.4l1.199 29.7 21 .3c44.7 0 109.199-5.099 171.899-28.2 6-2.1 11.7-4.499 17.701-6.899 66.299-28.5 112.202-80.7 140.7-123.3l41.697 19.199z",
    fill: "#8cd96b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m456.098 160.449-41.697-19.199c-28.499 42.599-74.401 94.799-140.7 123.3-6 2.401-11.7 4.799-17.701 6.899v-82.2c27.9-22.8 52.5-49.799 72.599-80.7 1.201-1.8 2.701-3.6 3.9-5.7l-36-16.8 135.601-82.199z",
    fill: "#5ab267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 388.15h75v60h-75z",
    fill: "#ff9f40"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffbe40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m75 448.15h75v60h-75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437 419.283v88.867h75v-60l-72.056-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437 418.15 75-30v-60h-75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362 388.15v60h150v-60z",
    fill: "#ffbe40"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m437 388.15h75v60h-75z",
    fill: "#ff9f40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseRevenue);
export default __webpack_public_path__ + "static/media/increase-revenue.caac43ec97907956f8009b53a0242a1e.svg";
export { ForwardRef as ReactComponent };